import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

import { colors } from "@/theme/overrides/colors";

const NoTrainingsIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 49 40" {...props}>
      <path
        d="M15.0127 24.1592H29.6473V16.4662H15.0127V24.1592Z"
        fill="#C0C5CD"
      />
      <path
        d="M40.5319 26.25H39.5166V14.9055H40.5319C41.7053 14.9071 42.6564 15.9211 42.6574 17.1729V23.9833C42.656 25.2348 41.7049 26.2488 40.5319 26.25Z"
        fill="#C0C5CD"
      />
      <path
        d="M35.535 31.0479H31.5029V9.57632H35.535C36.7084 9.57787 37.6595 10.5919 37.6606 11.8434V28.7808C37.6595 30.0323 36.7084 31.0463 35.535 31.0479Z"
        fill="#C0C5CD"
      />
      <path
        d="M6.99707 28.7808V11.8434C6.99816 10.5919 7.94926 9.57748 9.12263 9.57632H13.1548V31.0479H9.12263C7.94926 31.0463 6.99816 30.0323 6.99707 28.7808Z"
        fill="#C0C5CD"
      />
      <path
        d="M2 23.9849V17.1749C2.00109 15.923 2.95219 14.909 4.12556 14.9075H5.14085V26.252H4.12556C2.95219 26.2508 2.00145 25.2364 2 23.9849Z"
        fill="#C0C5CD"
      />
      <path d="M2 36.1018L47 2" stroke={colors.light} strokeWidth="3.32553" />
      <path d="M2 38.6292L47 4.52734" stroke="#C0C5CD" strokeWidth="3.32553" />
    </SvgIcon>
  );
};

export default NoTrainingsIcon;
